import React, { useContext } from 'react'
import { apiPut, apiDelete } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import { isEmpty } from 'lodash'
import dayjs from 'dayjs'
import { AiFillEdit, AiFillDelete } from 'react-icons/ai'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import useToastContext from 'hooks/useToastContext'
import helper from '../../../utils/helpers'
import { BsArrowUpShort } from 'react-icons/bs'
import { NavLink, Navigate } from 'react-router-dom'

const Table = ({
  questions,
  getAllQuestions,
  handelEdit,
  page,
  sort,
  setSort,
  manager
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  function Capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeStatusQuestion}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllQuestions()
      }
      // }
    } catch (error) {
      console.log('error in get all faqs list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_QUESTION')}
              </th>
              {/* <th scope='col' className='py-3 px-6'>
                {t('O_OPTION_A')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_OPTION_B')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_OPTION_C')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_OPTION_D')}
              </th> */}
              <th
                scope='col'
                className='py-3 px-1 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')}</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              {/* <th scope='col' className='py-3 px-6 text-right'>
                {t('O_CREATED_AT')}
              </th> */}
              {(manager?.add || user?.role === 'admin') && (
                <>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_STATUS')}
                  </th>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_ACTION')}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {questions &&
                questions?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-4 px-6 border-r'>{Capitalize(item?.question)}</td>
                  {/* <td className='py-4 px-6 border-r'>{Capitalize(item?.optionA)}</td>
                  <td className='py-4 px-6 border-r'>{Capitalize(item?.optionB)}</td>
                  <td className='py-4 px-6 border-r'>{Capitalize(item?.optionC)}</td>
                  <td className='py-4 px-6 border-r'>{Capitalize(item?.optionD)}</td> */}
                  <td className='py-4 px-6 border-r text-right'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-4 px-6 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } this question ?`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                        {(manager?.add ||
                    user?.role==='admin') && (
                  <td className='py-4 px-6 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                            <li
                              onClick={() => handelEdit(item)}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                            >
                              <span
                                title={t('O_EDIT')}
                                className='hover:text-blue-700 transition duration-150 ease-in-out'
                                data-bs-toggle='tooltip'
                              >
                                <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                              </span>
                            </li>
                      </ul>
                    </div>
                  </td>
                    )}
                </tr>
              ))}
            {isEmpty(questions) ? (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6 border-r' colSpan={9}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
